import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import Logo from '../../components/headers/Logo';
import AddListingButton from '../../components/headers/AddListingButton';
import LeftSideNav from '../../components/headers/LeftSideNav';
import RightSideNav from '../../components/headers/RightSideNav';
// import HeaderSearchForm from '../../components/forms/HeaderSearchForm';
import UserMenuDropDown from '../../components/headers/UserMenuDropDown';
import HeaderNotification from '../../components/headers/HeaderNotification';
import HeaderChatBtn from '../../components/headers/HeaderChatBtn';
import HeaderSearchTemplate from '../../components/headers/HeaderSearchTemplate';

const HeaderContainer = (props) => {

	const { token } = useSelector((state) => state.auth);
	const { user, notifications, notificationDescription, unreadNotifications, unreadMsgs } = useSelector((state) => state.user);
	const [isHomePage, setHomePage] = useState(false);
	
	useEffect(() => {
		if(window.location.pathname === '/') {
			setHomePage(true)
		} else {
			setHomePage(false)
		}
	}, [window.location.pathname]);


    return (
        <>
			<Logo 
				bgColor={props.bgColor}
				navbar={props.navbar} 
				isOwner={false}
			/>		

			{!isHomePage && (
				<HeaderSearchTemplate />
			)} 

			{isHomePage && (
				<AddListingButton />
			)}
			
			{user && (
				<UserMenuDropDown
					user={user}
				/>
			)}  

			{notifications && notificationDescription && (
				<HeaderNotification
					bgColor={props.bgColor} 
					navbar={props.navbar}
					notifications={notifications}
					notificationDescription={notificationDescription}
					unreadNotifications={unreadNotifications}
				/>
			)}  

			{token && user && (
				<HeaderChatBtn 
					bgColor={props.bgColor} 
					navbar={props.navbar}
					unreadMsgs={unreadMsgs}
				/>
			)} 
			
			{!token && (
				<RightSideNav
					bgColor={props.bgColor}
					navbar={props.navbar} 
				/>
			)} 

			<LeftSideNav 
				bgColor={props.bgColor} 
				navbar={props.navbar}
			/>
			
        </>
    );
};

export default HeaderContainer;